import AbstractPlatformNotification from "~/operatorApplication/ts/platform/AbstractPlatformNotification";
import PlatformNotificationParamsInterface from "~/operatorApplication/ts/platform/PlatformNotificationParamsInterface";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";

export default class WebPlatformNotification extends AbstractPlatformNotification {
    constructor() {
        super();
        if (this.isAvailable) {
            if (Notification.permission !== "granted") {
                Notification.requestPermission();
            }
        }
    }

    get isAvailable() {
        return !!window.Notification && !OperatorAccountStore.isCabinetIframe;
    }

    reposition() {
    }

    closeAll(): void {
    }

    closeByGroupId(groupId: string): void {
    }

    hasByGroupId(groupId: string): boolean {
        return false;
    }

    show(p: PlatformNotificationParamsInterface): void {
        if (this.isAvailable) {
            try {
                if (Notification.permission === "granted") {
                    /*var notification =*/
                    let notification = new Notification(p.title, {
                        body: p.text,
                        silent: true,
                        tag: p.groupId ? p.groupId : undefined,
                        // @ts-ignore
                        renotify: true,
                        icon: p.avatarUrl
                    });
                    notification.onclick = function () {
                        window.focus();
                        this.close();
                        if (p.click) {
                            p.click();
                        }
                    };
                }
            } catch (e) {

            }
        }
    }

}